import { useState } from 'react';

import { Button } from '@playbooks/ui/components/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@playbooks/ui/components/dropdown-menu';
import { FarIcon } from '@playbooks/ui/components/icon';
import { InputGroupTrigger } from '@playbooks/ui/components/input-group';

type PageSizePaginationProps = {
	meta: any;
	params: any;
	setParams: (params: any) => void;
	pageSizes?: number[];
};

const PageSizePagination = ({
	meta,
	params,
	setParams,
	pageSizes = [10, 20, 50, 100, 250, 500, 1000],
}: PageSizePaginationProps) => {
	const [open, setOpen] = useState(false);
	const pageSize = meta?.pageSize;

	// Methods
	const onSelect = pageSize => {
		setParams({ ...params, page: 0, pageSize });
		setOpen(false);
	};

	// Render
	return (
		<DropdownMenu open={open} onOpenChange={setOpen}>
			<DropdownMenuTrigger render={<InputGroupTrigger className='w-auto'>{pageSize} per page</InputGroupTrigger>} />
			<DropdownMenuContent align='end' className='w-max min-w-max'>
				<div>
					<ul>
						{pageSizes.map((option, i) => (
							<li key={i}>
								<Button
									type='button'
									variant='ghost'
									onClick={() => onSelect(option)}
									className='w-full justify-between whitespace-nowrap'>
									{option} per page
									{option === pageSize ? <FarIcon icon='check' className='size-3' aria-hidden /> : null}
								</Button>
							</li>
						))}
					</ul>
				</div>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { PageSizePagination };
export type { PageSizePaginationProps };
